<script setup lang="ts">
</script>

<template>
    <svg
        viewBox="41.77 41.5 352.71 42.07"
        role="img">
        <title>Progressive Insurance Logo</title>
        <g>
            <path class="st0" d="M224.783,44.45c-1.256-2.001-3.701-2.714-5.568-2.714h-18.981l-19.646,41.768h9.862l7.525-16.396l5.291,0.014
                c0.005,0,1.53,0.072,2.239,1.232c0.638,1.049,0.46,2.658-0.53,4.781c-2.384,5.109-4.273,10.41-4.273,10.41l10.004,0.006
                c0,0,0.373-2.029,1.212-4.037c0.76-1.828,3.057-7.59,3.078-7.646c1.922-4.746-0.445-6.619-1.947-7.547
                c3.79-0.397,6.5-2.183,8.036-5.353c1.251-2.584,3.185-6.768,3.203-6.811C226.205,48.194,225.618,45.778,224.783,44.45
                M214.761,51.662l-1.725,3.618l-1.028,2.149c-0.834,1.764-2.122,2.658-3.824,2.658h-6.877l5.218-11.363h7.528
                c0,0,0.698,0.025,1.019,0.541C215.373,49.759,215.266,50.587,214.761,51.662z"
            />
            <path class="st0" d="M119.486,44.45c-1.255-2.001-3.702-2.714-5.571-2.714H94.933L75.29,83.504h9.859l7.525-16.396l5.292,0.014
                c0.005,0,1.53,0.072,2.239,1.232c0.64,1.049,0.463,2.658-0.53,4.781c-2.384,5.109-4.272,10.41-4.272,10.41l10.006,0.006
                c0,0,0.37-2.029,1.209-4.037c0.761-1.828,3.057-7.59,3.078-7.646c1.924-4.746-0.444-6.619-1.946-7.547
                c3.791-0.397,6.503-2.183,8.035-5.353c1.251-2.584,3.187-6.768,3.205-6.811C120.908,48.194,120.318,45.778,119.486,44.45
                M109.463,51.662l-1.728,3.618l-1.028,2.149c-0.834,1.764-2.118,2.658-3.822,2.658h-6.879l5.367-11.363h7.379
                c0,0,0.702,0.025,1.019,0.541C110.074,49.759,109.967,50.587,109.463,51.662z"
            />
            <path class="st0" d="M143.131,75.395c1.96-4.084,4.687-9.914,7.577-16.086l3.366-7.188c3.474-7.401-0.451-10.62-5.435-10.62h-11.944
                c-5.041,0-8.601,2.38-10.884,7.272c-1.227,2.626-3.279,6.922-5.653,11.896l-5.043,10.567c-5.035,10.592,2.496,12.332,6.204,12.332
                h7.567C136.471,83.643,140.201,81.504,143.131,75.395 M129.72,75.812h-4.345c-0.793,0.039-2.338-0.205-1.161-2.738
                c1.687-3.637,8.753-18.865,10.196-21.927c0.983-2.088,2.004-2.507,3.332-2.507h5.374c1.04-0.044,1.958,0.524,1.119,2.311
                l-10.023,21.408C132.813,75.314,131.865,75.812,129.72,75.812z"
            />
            <path class="st0" d="M183.038,41.501H172.82c-5.213,0-9.443,2.651-11.604,7.272c-1.85,3.965-10.649,22.463-10.649,22.463
                c-3.218,6.764-1.355,12.332,7.448,12.332h7.857c6.277,0.064,9.364-0.922,12.231-7.199l7.319-16.039l-14.909-0.021l-3.279,6.979
                l5.196,0.01l-2.919,6.316c-0.854,1.83-1.431,2.199-3.434,2.199h-5.161c-1.532,0.014-2.09-0.766-1.158-2.738
                c1.172-2.492,10.45-21.865,10.45-21.865c1.049-2.204,1.68-2.537,3.303-2.537h5.338c1.288-0.008,1.984,0.597,1.122,2.305
                c-0.194,0.38-2.342,5.028-2.342,5.028l9.407,0.071l2.138-4.597C192.302,44.74,189.523,41.592,183.038,41.501z"/>
            <polygon class="st0" points="302.805,83.418 322.598,41.611 312.342,41.611 292.668,83.418 "
            />
            <polygon class="st0" points="347.723,41.62 324.77,78.449 336.381,41.62 325.756,41.62 316.008,83.418 329.728,83.418 
                358.389,41.62 "
            />
            <path class="st0" d="M269.207,68.918l-0.852-15.452c-0.102-1.86,0.354-4.392,3.764-4.392h6.848l3.514-7.454h-11.672
                c-9.248,0.01-12.4,5.655-12.041,12.295c0.217,4.06,0.787,17.263,0.787,17.263c0.143,3.182-1.082,4.67-4.061,4.674h-7.807
                l-3.498,7.582h12.447C264.887,83.434,269.75,78.045,269.207,68.918z"
            />
            <path class="st0" d="M292.551,68.918l-0.853-15.452c-0.102-1.86,0.355-4.392,3.764-4.392h6.848l3.518-7.454H294.15
                c-7.672,0.007-12.477,4.191-12.041,12.295c0.221,4.06,0.787,17.263,0.787,17.263c0.147,3.182-1.078,4.67-4.059,4.674h-7.609
                l-3.5,7.582h12.25C289.055,83.434,293.025,76.939,292.551,68.918z"
            />
            <path class="st0" d="M235.357,41.675l-19.539,41.753h24.713l3.6-7.562h-15.018l5.291-11.131h12.688l3.256-6.995h-12.734l4.051-8.678
                l13.172,0.022c0.027,0,3.445-7.414,3.445-7.414L235.357,41.675z"
            />
            <path class="st0" d="M361.754,41.675l-19.539,41.753h24.711l3.598-7.562h-15.012l5.287-11.131h12.689l3.256-6.995H364.01
                l4.053-8.678l13.17,0.022c0.023,0,3.443-7.414,3.443-7.414L361.754,41.675z"
            />
            <path class="st0" d="M51.904,83.553h-10.13l19.483-41.808h18.765c4.316,0.015,8.335,3.369,5.064,10.602
                c-1.858,4.106-3.498,7.653-4.326,9.359c-2.572,5.296-5.877,7.249-12.189,7.206c-4.139-0.029-9.864,0-9.864,0L51.904,83.553z
                M68.399,61.609c1.781,0.015,2.942-0.763,3.769-2.522c0.15-0.317,1.54-3.206,3.367-7.078c1.279-2.708,0.284-3.413-1.111-3.413
                l-6.372-0.008L62.045,61.6L68.399,61.609z"
            />
            <path class="st0" d="M387.677,45.417c0-1.872,1.523-3.396,3.414-3.396c1.879,0,3.392,1.524,3.392,3.396
                c0,1.888-1.513,3.41-3.392,3.41C389.2,48.827,387.677,47.304,387.677,45.417 M394.076,45.417c0-1.649-1.337-2.985-2.985-2.985
                c-1.658,0-2.995,1.336-2.995,2.985c0,1.664,1.337,3,2.995,3C392.739,48.416,394.076,47.081,394.076,45.417 M392.781,47.321h-0.551
                l-1.087-1.754h-0.854v1.754h-0.465v-3.803h1.655c0.391,0,0.642,0.018,0.929,0.188c0.285,0.159,0.427,0.5,0.427,0.82
                c0,0.747-0.525,1.025-1.203,1.042L392.781,47.321 M391,45.2c0.535,0,1.363,0.09,1.363-0.685c0-0.589-0.518-0.66-0.987-0.66h-1.086
                V45.2H391z"
            />
        </g>
    </svg>
</template>

<style>
.st0 {
    fill: #0077B3;
}
</style>
